/** State standar server action + useActionState. Aman diimpor dari komponen client. */
export type ActionState = {
  ok?: boolean;
  error?: string;
  message?: string;
  fieldErrors?: Record<string, string>;
  /** Nilai input yang dikirim ulang ke form agar tidak hilang saat validasi gagal (tanpa kata sandi). */
  values?: Record<string, string>;
};

export const initialActionState: ActionState = {};
